import { useRef } from 'react';
import { Input, DatePicker } from 'antd';
import XTable from 'components/XTable';
import { getApiLogApi } from 'api/apiLog';
import moment from 'moment';
const { RangePicker } = DatePicker;

const ApiLog = () => {
    const xTableRef = useRef();

    const actionBtns = [];

    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
        },

        {
            title: '操作人',
            dataIndex: 'userName',
        },
        {
            title: '操作内容',
            dataIndex: 'api',
        },
        {
            title: 'ip',
            dataIndex: 'ip',
        },
        {
            title: '操作时间',
            dataIndex: 'createTime',
            render: val => (val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '-'),
        },
    ];

    const queryItems = [
        {
            formItemApis: {
                label: '操作人',
                help: null,
                name: 'user_name',
            },
            item: <Input style={{ width: 150 }} allowClear />,
        },
        {
            formItemApis: {
                label: '申请日期',
                help: null,
                name: 'createDate',
            },
            item: <RangePicker format="YYYY-MM-DD" />,
        },
    ];

    // const downloadRecord = () => {
    //     const queryValue = xTableRef.current.queryForm?.getFieldsValue();
    //     getDownloadCheckApi(queryValue).then(res => {
    //         if (res.success) {
    //             const filename = `入住记录${moment().valueOf()}.xls`;
    //             downFile(res.file, filename);
    //         }
    //     });
    // };
    const handelParams = params => {
        const { createDate, ...otherParams } = params;
        let beginDate = '';
        let endDate = '';
        let newParams = otherParams;
        if (createDate && createDate.length) {
            beginDate = moment(createDate[0]).format('YYYY-MM-DD');
            endDate = moment(createDate[1]).format('YYYY-MM-DD');
            newParams = { ...otherParams, beginDate, endDate };
        }
        return newParams;
    };

    return (
        <div>
            <XTable
                handelParams={handelParams}
                columns={columns}
                queryItems={queryItems}
                actionBtns={actionBtns}
                api={getApiLogApi}
                rowKey="id"
                ref={xTableRef}
            />
        </div>
    );
};
export default ApiLog;
